import React from 'react';
import Button from '../../../components/base/Button';

const VPCHero: React.FC = () => {
  return (
    <section className="relative bg-gradient-to-br from-teal-50 to-blue-50 pt-20 pb-16 overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-10"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/06519044a6598c5911926e30aa82d935.jpg')`
        }}
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="space-y-4">
              <div className="inline-flex items-center px-4 py-2 bg-teal-100 text-teal-800 rounded-full text-sm font-medium">
                <i className="ri-shield-check-line mr-2"></i>
                24/7 Healthcare Access
              </div>
              <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                Virtual Primary Care
                <span className="block text-teal-600">Subscription</span>
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed">
                Unlimited access to board-certified physicians with guaranteed visits within 24 hours. 
                Your personal healthcare team, available whenever you need them.
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                variant="primary" 
                size="lg"
                className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 text-lg font-semibold whitespace-nowrap"
              >
                Start Your Subscription
              </Button>
              <Button 
                variant="outline" 
                size="lg"
                className="border-2 border-teal-600 text-teal-600 hover:bg-teal-50 px-8 py-4 text-lg font-semibold whitespace-nowrap"
              >
                Learn More
              </Button>
            </div>

            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-gray-200">
              <div className="text-center">
                <div className="text-3xl font-bold text-teal-600">24hrs</div>
                <div className="text-sm text-gray-600">Response Time</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-teal-600">24/7</div>
                <div className="text-sm text-gray-600">Availability</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-teal-600">∞</div>
                <div className="text-sm text-gray-600">Unlimited Visits</div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative z-10">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20female%20doctor%20in%20white%20coat%20smiling%20while%20using%20tablet%20for%20virtual%20consultation%2C%20modern%20medical%20office%20background%20with%20soft%20lighting%2C%20confident%20and%20approachable%20expression%2C%20high-quality%20medical%20photography&width=600&height=700&seq=vpc-hero-doctor&orientation=portrait"
                alt="Virtual Primary Care Doctor"
                className="w-full h-auto rounded-2xl shadow-2xl object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-xl shadow-lg border border-gray-100">
              <div className="flex items-center space-x-3">
                <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse"></div>
                <span className="text-sm font-medium text-gray-700">Dr. Sarah Johnson - Online Now</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VPCHero;